module.exports = __webpack_public_path__ + "static/media/mountain12.0a6652ec.jpg";